import * as React from "react"
import {SimOnlyPlan} from "../../Model/Sales/SimOnlyPlan";
import {CmsContent} from "../../Model/CmsContent/CmsContent";
import {optHtmlContent, renderDynamicContent} from "../../Utilities/CmsUtilities";
import {ApplicationContext} from "../../ApplicationContext";
import HeaderFooterWrapper from "../../Components/Navigation/HeaderFooterWrapper";
import {Navigate, useSearchParams} from "react-router-dom";
import PlanCarousel from "../../Components/Superdrug/PlanCarousel";
import {CarouselContentType} from "../../Model/Sales/CarouselContentType";
import {SALES_PORTAL_ROUTES} from "../../Routes/SalesPortalRoutes";

interface SuperdrugSimOnlyPlansProps {

    /**
     * Array of all content currently stored in the CMS that has been made available to the Sales Portal.
     */
    readonly cmsContent: CmsContent[]

    /**
     * Array of all SIM-only plans provided by the reseller.
     */
    readonly simOnlyPlans: SimOnlyPlan[]

}

/**
 * Function will render the Superdrug-specific SIM-only plans page.
 */
const SuperdrugSimOnlyPlans = (props: SuperdrugSimOnlyPlansProps): JSX.Element => {
    const [searchParams] = useSearchParams()
    const plan = searchParams.get("plan") || undefined
    const promo = searchParams.get("promo") || undefined
    const applicationContext = React.useContext(ApplicationContext)

    React.useEffect(() => {
    }, [])

    const optOurPlansPage = optHtmlContent(props.cmsContent, "sp-page-our-plans")

    if (!optOurPlansPage) {
        return <Navigate to={SALES_PORTAL_ROUTES.InternalError(applicationContext.urlContext)}/>
    } else {
        return (
            <HeaderFooterWrapper cmsContent={props.cmsContent}>
                {renderDynamicContent(optOurPlansPage, [
                    {key: "SIM_ONLY_PLANS", value: <PlanCarousel availableSimOnlyPlans={props.simOnlyPlans}
                                                                 carouselContentType={CarouselContentType.EXPANDED}
                                                                 initialPlanCode={plan}
                                                                 initialPromoCode={promo}/>}
                ])}
            </HeaderFooterWrapper>
        )
    }

}

export default SuperdrugSimOnlyPlans